import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import loggingUserSlice from "../features/loggingUser/loggingUserSlice";
import settingsSlice from "../features/settings/settingsSlice";
import itemsSlice from "../features/items/itemsSlice";
import processesSlice from "../features/processes/processesSlice";
import partiesSlice from "../features/parties/partiesSlice";
import processRatesSlice from "../features/parties/processRatesSlice";
import paymentsSlice from "../features/payments/paymentsSlice";
import usersSlice from "../features/users/usersSlice";
import accountTypesSlice from "../features/accounts/accountTypesSlice";
import accountsSlice from "../features/accounts/accountsSlice";
import materialsSlice from "../features/materials/materialsSlice";
import itemSizesSlice from "../features/itemSizes/itemSizesSlice";
import activityLogsSlice from "../features/activityLogs/activityLogsSlice";
import stockSlice from "../features/stock/stockSlice";
import processDefinitionsSlice from "../features/processDefinitions/processDefinitionsSlice";
import processOrdersSlice from "../features/processOrders/processOrdersSlice";
import processReceivesSlice from "../features/processReceives/processReceivesSlice";
import devFeedbackSlice from "../features/devFeedback/devFeedbackSlice";

export const store = configureStore({
  reducer: {
    loggingUser: loggingUserSlice,
    settings: settingsSlice,
    items: itemsSlice,
    processes: processesSlice,
    parties: partiesSlice,
    processRates: processRatesSlice,
    payments: paymentsSlice,
    users: usersSlice,
    accountTypes: accountTypesSlice,
    accounts: accountsSlice,
    materials: materialsSlice,
    itemSizes: itemSizesSlice,
    activityLogs: activityLogsSlice,
    stock: stockSlice,
    processDefinitions: processDefinitionsSlice,
    processOrders: processOrdersSlice,
    processReceives: processReceivesSlice,
    devFeedback: devFeedbackSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
